module.exports = __webpack_public_path__ + "img/summary_7.c65c200f.png";